// ----------------------------------------------------------
// IMPORTS
// ----------------------------------------------------------
import EgoModal from '@egodesign/modal'
import EgoForm from '@egodesign/form'
import Swiper from 'swiper/bundle'
import { bulletHighlightedSlider } from '../components/bullet-highlighted'
import 'swiper/css/bundle'

// ----------------------------------------------------------
// MODULES
// Helper functions
// ----------------------------------------------------------
import { findProduct, getParentWithProductData, updateQtyInAllProducts, updateCartItems, updateSparePartCounter, removeAllSparePartItems, addSparePartFromSelector, handleTooltip, vanillaFade } from '../modules/tools'

// ----------------------------------------------------------
// STORE
// Instance of Zustand Store
// ----------------------------------------------------------
import store from '../../../state/store'
import { searchBarButtonDisabled } from '../components/search.bar'
import { nextToQuoterFormGTM, sparePartViewDetailGTM } from '../modules/marketing/gtm'

// Getters and setters from the store
// This only modifies STATE
const { getProducts, getCartProducts, addToCart, removeFromCart, removeOneItemFromCart, isProductInCart } = store.getState()

// ----------------------------------------------------------
// SELECTORS
// ----------------------------------------------------------
let modal
const modal_detail = document.querySelector('#modal-detail')
const modalDetailRemoveBtn = modal_detail.querySelector('.modal-detail__remove-btn')
const quoter = document.querySelector('.quoter')
const toggle_quoter = document.querySelector('.quoter #accordion-quoter')
const quoter_items_container = document.querySelector('.quoter .items')
const btn_mosaic = document.querySelectorAll('.btn-filter.mosaic-view')
const btn_list = document.querySelectorAll('.btn-filter.list-view')

// ----------------------------------------------------------
// GLOBALS
// ----------------------------------------------------------
window.addToCartHandler = function (event) {
    // STATE CHANGE
    addToCart(event.target.dataset.product)

    // UI CHANGE
    if (quoter.classList.contains('--hidden')) {
        quoter.classList.remove('--hidden')
    }

    updateCartItems()
}

window.addQtyHandler = function (event) {
    const targetElement = getParentWithProductData(event.currentTarget)

    if (targetElement === null) {
        console.error("No parent element with 'data-product' found.")
        return
    }

    // STATE CHANGE
    addToCart(targetElement.dataset.product)

    // UI CHANGE
    updateCartItems()
    updateSparePartCounter()
}

window.removeItemHandler = function (event) {
    const targetElement = getParentWithProductData(event.currentTarget)

    // STATE CHANGE
    removeFromCart(targetElement.dataset.product)

    // UI CHANGE
    updateCartItems()

    if (quoter_items_container.childNodes.length === 0) {
        quoter.classList.add('--hidden')
    }
}

window.minusItemHandler = function (event) {
    const targetElement = getParentWithProductData(event.currentTarget)

    if (targetElement === null) {
        console.error("No parent element with 'data-product' found.")
        return
    }

    // STATE CHANGE
    removeOneItemFromCart(targetElement.dataset.product)

    // UI CHANGE
    updateCartItems()
    updateSparePartCounter()
}

removeAllSparePartItems()
addSparePartFromSelector(quoter)

window.addEventListener('load', async () => {
    // ----------------------------------------------------------
    // SETUP
    // 1) Initialize the modal, and the selectors
    // 2) Initialize the swiper
    // ----------------------------------------------------------
    modal = new EgoModal({
        element: modal_detail,
    })
    const modal_title = modal_detail.querySelector('dialog .product__text .title')
    const modal_code = modal_detail.querySelector('dialog .product__text .code')

    const modal_add_to_cart_btn = modal_detail.querySelector('button.cotizar')

    const modal_img = modal_detail.querySelector('dialog .spare-part-image')

    const modal_landing_btn = modal_detail.querySelector('dialog .spare-part__landingpage')

    // Swiper
    const sparePartsSwiper = new Swiper('.swiper.swiper-card-spare-parts', {
        // Default parameters
        slidesPerView: 1,
        grabCursor: true,

        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },

        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },

        //Responsive breakpoints
        breakpoints: {
            900: {
                slidesPerView: 3,
                spaceBetween: 30,
            },
            640: {
                slidesPerView: 2,
                spaceBetween: 30,
            },
        },
    })

    // ----------------------------------------------------------
    // API CALL
    // Im getting the products, and the cart products if there is any
    // The products will be used to hydratate the product list and the cart products will be used to hydratate the quoter
    // ----------------------------------------------------------
    window.products = await getProducts()
    window.cart_products = getCartProducts()

    // UI CHANGE
    // ----------------------------------------------------------
    // LIST VIEW CONTROL
    // Here you can find the logic to change the list view of the products and its selectors
    // Must come AFTER the products are rendeted in the HTML because it needs to get the elements
    // ----------------------------------------------------------

    if (btn_mosaic.length) {
        btn_mosaic.forEach((btn) => {
            btn.addEventListener('click', (e) => {
                const container = e.target.closest('.cards-with-filter')

                const gridProducts = container.querySelector('.cards-with-filter__cards.--grid-view')

                const listProducts = container?.querySelector('.cards-with-filter__cards.--list-view')

                if (listProducts) {
                    listProducts.style.display = 'none'
                }

                container.classList.remove('--show-list-view')
                vanillaFade({
                    element: gridProducts,
                    enter: true,
                    time: 250,
                    displayType: 'grid',
                })

                const btnList = container.querySelector('.btn-filter.list-view')
                const btnMosaic = container.querySelector('.btn-filter.mosaic-view')
                btnList.classList.remove('--selected')
                btnMosaic.classList.add('--selected')
            })
        })
    }

    if (btn_list.length) {
        btn_list.forEach((btn) => {
            btn.addEventListener('click', (e) => {
                const container = e.target.closest('.cards-with-filter')

                const gridProducts = container.querySelector('.cards-with-filter__cards.--grid-view')

                const listProducts = container?.querySelector('.cards-with-filter__cards.--list-view')

                if (gridProducts) {
                    gridProducts.style.display = 'none'
                }

                container.classList.add('--show-list-view')
                vanillaFade({
                    element: listProducts,
                    enter: true,
                    time: 250,
                    displayType: 'grid',
                })
                const btnList = container.querySelector('.btn-filter.list-view')
                const btnMosaic = container.querySelector('.btn-filter.mosaic-view')
                btnMosaic.classList.remove('--selected')
                btnList.classList.add('--selected')
            })
        })
    }

    modalDetailRemoveBtn?.addEventListener('click', () => modal.close())

    // ----------------------------------------------------------
    // PRODUCT FUNCTIONALITY
    // Here is all the logic related to the products
    // 1) Add to cart
    // 2) View details
    // 3) Remove from cart
    // ----------------------------------------------------------

    // Get the buttons
    // OPEN MODAL BTN
    const btns_view_details = document.querySelectorAll('.modal-btn-detail') // The one that open the modal in each card

    // OPEN MODAL HANDLER
    // Add the handler to open the modal
    for (const btn of btns_view_details) {
        btn.addEventListener('click', (e) => {
            // Find the product according to the data-product attribute that is the id
            const product_to_show = findProduct(window.products, e.target.dataset.product)

            // Rehydrate the modal with the data
            modal_add_to_cart_btn.dataset.product = e.target.dataset.product
            modal_title.textContent = product_to_show.name
            modal_code.textContent = `CÓDIGO: ${product_to_show.code}`
            modal_img.src = product_to_show.img
            if (product_to_show.landingpage && product_to_show.landingpage != window.location.pathname) {
                modal_landing_btn.href = product_to_show.landingpage
                modal_landing_btn.style.display = ''
            } else {
                modal_landing_btn.style.display = 'none'
            }

            if (product_to_show.description) {
                const modal_description = modal_detail.querySelector('dialog .product__text .description')
                modal_description.innerHTML = product_to_show.description
            }

            if (isProductInCart(e.target.dataset.product)) {
                modal_detail.classList.add('--selected')
                modalDetailRemoveBtn.dataset.product = e.target.dataset.product
            } else {
                modal_detail.classList.remove('--selected')
            }

            // Open the modal with the data populated
            modal.open()

            sparePartViewDetailGTM(product_to_show)
        })
    }

    // ADD TO CART BTN in MODAL
    modal_add_to_cart_btn?.addEventListener('click', (e) => {
        addProdModalHandler(e)
        modal.close()
    })

    function addProdModalHandler(event) {
        const prod_id = event.target.dataset.product

        // STATE CHANGE
        addToCart(prod_id)

        // UI CHANGE
        if (quoter.classList.contains('--hidden')) {
            quoter.classList.remove('--hidden')
        }
        updateCartItems()
        updateQtyInAllProducts(event)
    }

    // ----------------------------------------------------------
    // QUOTER
    // Here is all the logic related to the quoter
    // 1) Add quantity
    // 2) Remove item
    // ----------------------------------------------------------

    if (quoter) {
        if (window.cart_products.length > 0) {
            // if we have products in the cart, show the quoter
            quoter.classList.remove('--hidden')

            // UI CHANGE
            updateCartItems()
        }

        if (toggle_quoter) {
            toggle_quoter.addEventListener('click', (e) => {
                // const accordion = e.currentTarget.parentElement;
                e.currentTarget.classList.toggle('active')
            })
        }
    }

    // TOOLTIP
    const viewsBtn = document.querySelectorAll('.btn-filter')
    if (viewsBtn.length) handleTooltip(viewsBtn)
})

// ----------------------------------------------------------
// SEARCH BAR
// ----------------------------------------------------------
const searchForm = document.querySelector('#searchBarForm')

if (searchForm) {
    const searchBarForm = new EgoForm({
        element: searchForm,
        submitType: 'GET',
        submitDataForm: 'formData',
    })
}

// Componentes
bulletHighlightedSlider()
searchBarButtonDisabled()

// Marketing
nextToQuoterFormGTM(getCartProducts)
